/**
 * Nom affiché d'un joueur : fonctions pures, sans I/O ni store.
 *
 * Le satellite renvoie, à côté du gamertag (`name`), le pseudo Recube du joueur (`displayName`), lu dans
 * le registre de RecubeAuthMod. Absent : satellite sans registre Recube, ou joueur sans pseudo. Les avatars
 * (mc-heads par nom) restent sur le gamertag.
 */

/**
 * « pseudo (gamertag) » quand le pseudo Recube existe et diffère du gamertag (sans casse), sinon le
 * pseudo seul, sinon le gamertag, sinon `fallback` (« Inconnu », uuid, « Systeme »… selon l'appelant).
 */
export function formatPlayerName(
  name: string | null | undefined,
  displayName?: string | null,
  fallback = 'Inconnu',
): string {
  const gamertag = name?.trim() ?? '';
  const pseudo = displayName?.trim() ?? '';
  if (pseudo && gamertag && pseudo.toLowerCase() !== gamertag.toLowerCase()) return `${pseudo} (${gamertag})`;
  return pseudo || gamertag || fallback;
}

/**
 * Nom à saisir pour retrouver un joueur (recherche, sanction, whitelist) : son pseudo Recube s'il en a
 * un (unique, cherché en premier par le satellite), sinon son gamertag.
 */
export function playerLookupName(name: string | null | undefined, displayName?: string | null): string {
  return displayName?.trim() || name?.trim() || '';
}
